const currentYear = new Date().getFullYear();

export const Copyright = `© 2023-${currentYear} GRAY HORSE GROUP 2 LLC.`;
